import { layoutHorizontalGapStyles, maxWidth } from 'mui/components/sharedStyles/layoutStyles';

export const SharedContainerStepsStyles = ({ theme }) => `
  ${layoutHorizontalGapStyles({ theme })};

  ${theme.breakpoints.up('md')} {
    max-width: 624px;
    margin: 0 auto;
  }

`;

export const SharedStyledResultsWrapper = ({ theme }) => `
  margin-top: -13px;
  z-index: 2;
  position: relative;
  

  > div {
    display: flex;
    flex-direction: column;
  }

  ${theme.breakpoints.up('lg')} {
    ${maxWidth};
   max-width: 1292px;
   margin: 0 auto;
   margin-top: 70px;
    > div {
        width: 100%;
        flex-direction: row;
        justify-content: space-around;
         gap: ${theme.DS_spacing(['xxl'])};
    }
  }
`;

export const SharedColumnSummary = ({ theme }) => `

   h1 {
     margin: ${theme.DS_spacing(['sm'])} 0 ${theme.DS_spacing(['md'])}; 
   }
   ${theme.breakpoints.up('md')} {
     margin: 0 ${theme.DS_spacing(['lgx'])} ;
   }
   
   ${theme.breakpoints.up('lg')} {
        margin: unset;
        max-width: unset;
        flex: 0 1 50%;
        h1 {
          margin-top: 0; 
       }
    }
`;

export const SharedColumnImage = ({ theme }) => `

    order: 1;
  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
    max-height: 184px;
    ${theme.breakpoints.up('md')} {
     max-height: 292px;
    
    }
  }
  
  ${theme.breakpoints.up('lg')} {
     order: 2;
     flex: 0 1 50%;
     .gatsby-image-wrapper {
         min-height: 596px;
         max-height: 100%;
     }
  }
`;
